import { render } from "./MessageReviewPage.vue?vue&type=template&id=20edf6f9"
import script from "./MessageReviewPage.vue?vue&type=script&lang=js"
export * from "./MessageReviewPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__